import type { LegislationNumberingFormat, Tenant } from "@repo/types";

export type LegislationNumberField =
  | "draftNumber"
  | "ordinanceNumber"
  | "resolutionNumber";

export type ReservedLegislationNumber = {
  type: "bill" | "ordinance" | "resolution";
  field: LegislationNumberField;
  number: string;
  committed: boolean;
};

export type InvalidLegislationNumber = {
  field: LegislationNumberField;
  previousValue: string;
  format: LegislationNumberingFormat;
};

export const getDocumentLegislationNumberFormat = (
  field: LegislationNumberField,
  tenant?: Tenant | null
): LegislationNumberingFormat => {
  if (field === "draftNumber") return tenant?.billNumberingFormat ?? "number";
  if (field === "resolutionNumber") {
    return tenant?.resolutionNumberingFormat ?? "yearNumber";
  }

  return tenant?.ordinanceNumberingFormat ?? "number";
};
